module.exports = __webpack_public_path__ + "static/media/2017-06-23_52.0d8d227e.JPG";